export default {
  getWebcomments: '/api/web/v2/comment/getwebcomments',
  deleteComment: '/api/web/v2/comment/deletecomment',
  setWebComment: '/api/web/v2/comment/setwebcomment',
  gettopcomments: '/api/web/v2/comment/gettopcomments'
}
